import { UNIT_DEFAULT, type WindowUnit } from '../longWindows';
import { WINDOW_NUMBER_FIELD } from './defs';

type BlocklyModule = typeof import('blockly/core');
type Block = InstanceType<BlocklyModule['Block']>;

/**
 * The pattern window in blocks: the unit, then the number from that unit's list, as in the
 * Sentence view (owner, 30 Sep). Two pieces only Blockly itself can provide, registered once:
 *   • `field_window_number` — a `FieldDropdown` (its menu is `windowNumberOptions` in defs.ts)
 *     that takes any whole number and shows its own value. Blockly checks a dropdown's new value
 *     against the options it generated last — at construction, before the block and its UNIT
 *     exist — so a plain dropdown would refuse a stored 200 days while loading and silently
 *     keep its default.
 *   • `kkp_window` — picking another unit sets that unit's default number, as the Sentence view
 *     does. UNIT loads before WIN (`ruleToWorkspaceState`), so loading a rule keeps its number.
 */
export function registerWindowBlocks(B: BlocklyModule): void {
  if (!B.registry.hasItem(B.registry.Type.FIELD, WINDOW_NUMBER_FIELD)) {
    class FieldWindowNumber extends B.FieldDropdown {
      protected override doClassValidation_(newValue?: string): string | null {
        return typeof newValue === 'string' && /^\d+$/.test(newValue) ? newValue : null;
      }
      protected override getText_(): string | null {
        return this.getValue();
      }
    }
    B.fieldRegistry.register(WINDOW_NUMBER_FIELD, FieldWindowNumber);
  }
  if (!B.Extensions.isRegistered('kkp_window')) {
    B.Extensions.register('kkp_window', function (this: Block) {
      const block = this;
      block.getField('UNIT')?.setValidator((next: string) => {
        const unit = Number(next) as WindowUnit;
        if (next !== block.getFieldValue('UNIT') && unit in UNIT_DEFAULT) block.setFieldValue(String(UNIT_DEFAULT[unit]), 'WIN');
        return next;
      });
    });
  }
}
